import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctUInt112, FctUinteger32 } from '../../../../Fct/generics';
import { FaDatabase } from 'react-icons/fa';
export var GetReserves = createPlugin({
    protocol: 'UNISWAP',
    type: 'GETTER',
    method: 'getReserves',
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_pool_v2', icon: FaDatabase }), // TODO: Add Uniswap V2 pools to options
            methodParams: {},
        },
        output: {
            reserve0: new FctUInt112({ innerIndex: 0 }),
            reserve1: new FctUInt112({ innerIndex: 1 }),
            blockTimestamp: new FctUinteger32({ innerIndex: 2 }),
        },
    }); },
});
